import { createStyles, makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';

const useStyles = makeStyles((theme: ITheme) => ({
  icon: {
    height: `${theme.spacing(2)}px !important`,
    width: `${theme.spacing(2)}px !important`,
  },
  publishedIcon: {
    fill: `${theme.palette.grey[600]} !important`,
  },
  finalIcon: {
    fill: `${theme.palette.secondary.main} !important`,
  },
}));

export default useStyles;
